export default __webpack_public_path__ + "static/7-bde716953e26fd96c327432870c3e632.jpg";